import { getDb, type ProgressEntry } from './db.ts';

export type ItemState = 'new' | 'inProgress' | 'finished';

export async function listProgress(): Promise<ProgressEntry[]> {
  const db = await getDb();
  return db.getAll('progress');
}

export async function getProgress(itemId: string): Promise<ProgressEntry | undefined> {
  const db = await getDb();
  return db.get('progress', itemId);
}

export async function saveProgress(entry: ProgressEntry): Promise<void> {
  const db = await getDb();
  await db.put('progress', entry);
}

export async function resetProgress(itemId: string): Promise<void> {
  const db = await getDb();
  await db.delete('progress', itemId);
}

export async function resetAllProgress(): Promise<void> {
  const db = await getDb();
  await db.clear('progress');
}

/**
 * Anteil der bereits gehoerten Folge, 0..1.
 *
 * Naeherung ueber die Kapitelanzahl: Kapitel eines Hoerspiel-Albums sind
 * ungefaehr gleich lang, deshalb ist (Kapitelindex + Anteil im Kapitel) durch
 * Kapitelanzahl genau genug fuer einen Fortschrittsring.
 */
export function progressFraction(
  trackIndex: number,
  positionMs: number,
  trackDurationMs: number | null,
  trackCount: number,
): number {
  if (trackCount <= 0) return 0;
  const withinTrack =
    trackDurationMs && trackDurationMs > 0 ? Math.min(1, positionMs / trackDurationMs) : 0;
  return Math.min(1, (trackIndex + withinTrack) / trackCount);
}

export function stateOf(entry: ProgressEntry | undefined): ItemState {
  if (!entry) return 'new';
  return entry.state;
}
